import React from "react";
import { Link } from "react-router-dom";
import facebookLogo from "../assets/images/facebook.svg";
import instagramLogo from "../assets/images/svgexport-15.svg";
import twitterLogo from "../assets/images/svgexport-16.svg";
import youtubeLogo from "../assets/images/svgexport-17.svg";
import { trackInstagramClick } from "../utils/firebase";

const Footer = () => {
	return (
		<div className="footer text-[#808080] bg-black relative z-[1] px-4 pb-12 pt-8 lg:py-8 2xl:text-2xl">
			<div className="flex flex-col gap-6 max-w-[1280px] m-auto">
				<div className="social-links flex gap-8 opacity-100">
					<a
						href="https://www.instagram.com/"
						className="hover:scale-150 transition-all"
						onClick={trackInstagramClick}
						target="_blank"
					>
						<img className="2xl:w-8" src={instagramLogo} alt="instagram logo" />
					</a>
					<a
						href="https://www.facebook.com/"
						className="hover:scale-150 transition-all"
						target="_blank"
					>
						<img className="2xl:w-8" src={facebookLogo} alt="facebook logo" />
					</a>
					<a
						href="https://x.com/"
						className="2xl:w-8 hover:scale-150 transition-all"
						target="_blank"
					>
						<img className="2xl:w-8" src={twitterLogo} alt="twitter logo" />
					</a>
				</div>
				<p>Questions? Call 000-800-919-1743</p>
				<div>
					<ul className="flex-col gap-2 flex md:flex-row md:gap-0 flex-wrap justify-between">
						<li className="group relative hover:text-gray-200">
							<Link to="/my-list">
								My List
								<span class="absolute -bottom-1 left-0 w-0 transition-all h-0.5 bg-white group-hover:w-full"></span>
							</Link>
						</li>
						<li className="group relative hover:text-gray-200">
							<Link to="/search">
								Gemini Search
								<span class="absolute -bottom-1 left-0 w-0 transition-all h-0.5 bg-white group-hover:w-full"></span>
							</Link>
						</li>
						<li className="group relative hover:text-gray-200">
							<Link to="#">
								Terms of use
								<span class="absolute -bottom-1 left-0 w-0 transition-all h-0.5 bg-white group-hover:w-full"></span>
							</Link>
						</li>
						<li className="group relative hover:text-gray-200">
							<Link to="#">
								Privacy
								<span class="absolute -bottom-1 left-0 w-0 transition-all h-0.5 bg-white group-hover:w-full"></span>
							</Link>
						</li>
					</ul>
				</div>
				<p className="text-[11px] 2xl:text-xl">
					&copy; 2001 - {new Date().getFullYear()} Watchflix
				</p>
			</div>
		</div>
	);
};

export default Footer;
